import { createFileRoute } from "@tanstack/react-router";
import { AdminAiActivityPage } from "@/features/admin/org-ai";

/** ALP-86: platform-wide AI activity (every org, org filter), a tab of the admin shell. */
export const Route = createFileRoute("/admin/ai-activity")({
  head: () => ({ meta: [{ title: "AI activity · Admin · Malfak" }] }),
  component: AdminAiActivityPage,
});
